import { createContext, useContext, useState, useEffect, useCallback } from "react";

const dict = {
  it: {
    tagline: "Programma fedeltà",
    login_title: "Accesso Operatore",
    email: "Email", password: "Password", login: "ACCEDI", logout: "Esci",
    operator: "Operatore",
    tap_card: "APPOGGIA LA TESSERA SUL LETTORE",
    reader_ready: "Lettore pronto", reader_off: "Lettore non rilevato",
    search_customer: "CERCA CLIENTE", new_customer: "NUOVO CLIENTE", catalog: "CATALOGO",
    manual_uid: "Inserisci UID manualmente", scan_or_type: "Appoggia la tessera oppure digita lo UID",
    points: "PUNTI STELLA", card: "Tessera", customer_since: "Cliente dal", no_card: "Nessuna tessera",
    earn_points: "+ CARICA PUNTI", use_points: "UTILIZZA PUNTI",
    history: "STORICO", edit: "MODIFICA", replace_card: "SOSTITUISCI TESSERA", back_home: "TORNA ALLA HOME",
    back: "INDIETRO", cancel: "ANNULLA", confirm: "CONFERMA", save: "SALVA",
    valid_amount: "IMPORTO VALIDO", points_to_add: "PUNTI DA ACCREDITARE",
    current_balance: "Saldo attuale", new_balance: "Nuovo saldo",
    confirm_points: "CONFERMA", operation_done: "OPERAZIONE COMPLETATA",
    reward_delivered: "PREMIO CONSEGNATO", remaining_balance: "Saldo residuo",
    confirm_delivery: "CONFERMA CONSEGNA", reward: "Premio", cost: "Costo",
    need_more: "SERVONO ALTRI", select: "SELEZIONA", available: "DISPONIBILE", out_of_stock: "ESAURITO",
    insufficient: "PUNTI INSUFFICIENTI",
    date_time: "Data/Ora", operation: "Operazione", amount: "Importo", balance: "Saldo",
    search_placeholder: "Cellulare, nome, cognome o UID tessera...",
    open_customer: "APRI CLIENTE", no_results: "Nessun risultato", state: "Stato",
    card_not_associated: "TESSERA NON ASSOCIATA",
    assoc_new: "ASSOCIA A NUOVO CLIENTE", assoc_existing: "ASSOCIA A CLIENTE ESISTENTE",
    warning: "ATTENZIONE", duplicate_phone: "Esiste già un cliente con questo numero.",
    assoc_to_existing: "ASSOCIA QUESTA TESSERA AL CLIENTE ESISTENTE", continue_anyway: "CONTINUA COMUNQUE (ADMIN)",
    name: "Nome", surname: "Cognome", phone: "Cellulare", birth_date: "Data di nascita",
    address: "Indirizzo", city: "Città", province: "Provincia", zip: "CAP",
    fiscal_code: "Codice Fiscale", notes: "Note", gender: "Sesso",
    privacy_consent: "Consenso privacy", marketing_consent: "Consenso marketing",
    required_fields: "Nome, cognome e cellulare sono obbligatori",
    customer_created: "Cliente creato", customer_updated: "Cliente aggiornato",
    card_associated: "Tessera associata", card_replaced: "Tessera sostituita",
    new_card_uid: "UID nuova tessera",
    admin: "ADMIN", dashboard: "Dashboard", operators: "Operatori", settings: "Impostazioni",
    reports: "Report", audit: "Audit Log", catalog_mgmt: "Catalogo",
    today: "Oggi", yesterday: "Ieri", last7: "Ultimi 7 giorni", month: "Mese corrente",
    prev_month: "Mese precedente", custom: "Personalizzato",
    total_customers: "Clienti totali", new_today: "Nuovi oggi", new_month: "Nuovi nel mese",
    points_earned_period: "Punti accreditati (periodo)", points_redeemed_period: "Punti utilizzati (periodo)",
    points_circulating: "Punti circolanti", rewards_delivered: "Premi consegnati",
    top_balance: "Top 10 per saldo", top_earned: "Top 10 per punti accumulati", top_rewards: "Top premi",
    add_reward: "NUOVO PREMIO", add_operator: "NUOVO OPERATORE", active: "Attivo", inactive: "Disattivato",
    role: "Ruolo", stock: "Stock", stock_tracking: "Traccia stock", category: "Categoria",
    points_required: "Punti richiesti", description: "Descrizione", image: "Immagine",
    export_csv: "ESPORTA CSV", reverse: "STORNA", reason: "Motivo storno",
    program_rule: "Regola punti", euro_per_step: "Euro per punto (soglia)", points_per_step: "Punti per soglia",
    session_timeout: "Timeout sessione cliente (secondi)", program_name: "Nome programma",
    settings_saved: "Impostazioni salvate", error: "Operazione non riuscita",
    deactivate_customer: "Disattiva cliente", activate_customer: "Riattiva cliente",
    deactivate: "Disattiva", activate: "Attiva",
    inactivity_warn: "Ritorno alla home per inattività",
    uid_label: "UID", loading: "Caricamento...",
    scan_ticket: "SCANSIONA TICKET", keypad: "TASTIERINO",
    drop_ticket: "Trascina qui l'immagine del ticket oppure tocca per selezionarla",
    analyzing: "Analisi AI del ticket in corso...",
    ticket_pending: "Ticket in attesa dal lettore", no_pending: "Nessun ticket in attesa",
    auto_credit_lbl: "ACCREDITO AUTOMATICO", auto_credit_hint: "I ticket dal lettore vengono accreditati da soli al cliente aperto",
    ticket_credited_title: "TICKET ACCREDITATO", auto_tag: "AUTOMATICO",
    cancel_credit: "ANNULLA RICARICA", credit_cancelled: "Ricarica annullata",
    apply_ticket: "ACCREDITA", discard: "SCARTA",
    ticket_verify: "Verifica dati ticket", ticket_number_lbl: "Numero ticket",
    puntato_lbl: "IMPORTO PUNTATO (base punti)", inserito_lbl: "Inserito", vincita_lbl: "Vincita netta", pagabile_lbl: "Pagabile",
    tickets_nav: "Ticket VLT",
    happy_birthday: "BUON COMPLEANNO!", birthday_bonus_lbl: "Bonus compleanno automatico",
    birthday_points_lbl: "Punti bonus compleanno",
    birthday_hint: "Accreditati automaticamente alla prima identificazione del cliente nel giorno del compleanno (una volta l'anno)",
    campaigns_nav: "Campagne", add_campaign: "NUOVA CAMPAGNA", no_campaigns: "Nessuna campagna. Creane una per lanciare i punti doppi!",
    multiplier: "Moltiplicatore", camp_from: "Dal", camp_to: "Al",
    camp_days: "Giorni della settimana", camp_days_hint: "Nessun giorno selezionato = tutti i giorni del periodo",
    camp_all_days: "Tutti i giorni", camp_scope: "Si applica a",
    scope_ticket: "Solo ticket scansionati", scope_all: "Tutti gli accrediti",
    camp_running: "IN CORSO", camp_scheduled: "PROGRAMMATA", camp_expired: "SCADUTA", camp_disabled: "DISATTIVATA",
    camp_saved: "Campagna salvata", camp_delete: "Eliminare la campagna", camp_required: "Nome e periodo obbligatori",
    bridge_nav: "Lettore", bridge_configured: "Bridge configurato", bridge_not_configured: "Bridge non ancora configurato",
    bridge_setup_btn: "CONFIGURA E SCARICA PACCHETTO (una volta sola)",
    bridge_download_btn: "SCARICA PACCHETTO", bridge_regen_btn: "RIGENERA TOKEN",
    bridge_regen_confirm: "Rigenerare il token? Il pacchetto già installato smetterà di funzionare e andrà riscaricato.",
    bridge_configured_toast: "Bridge configurato, download in corso...",
    bridge_steps_title: "Installazione sul PC del banco",
    bridge_step1: "Scarica il pacchetto ZIP e copialo sul PC collegato allo scanner fi-800R",
    bridge_step2: "Estrai la cartella (serve Python installato: python.org, spunta \"Add to PATH\")",
    bridge_step3: "Doppio click su AVVIA_BRIDGE.bat — nessuna riga di comando necessaria",
    bridge_step4: "Imposta lo scanner per salvare i JPG nella cartella \"scansioni\" (o modifica \"folder\" in bridge_config.json)",
    vip_bronze: "Bronzo", vip_silver: "Argento", vip_gold: "Oro",
    vip_level: "Livello", vip_auto: "Automatico",
    vip_missing_points: "mancano {n} ⭐ per {tier}",
    vip_total_earned: "Punti accumulati da sempre",
    vip_bonus_tag: "Bonus VIP",
    reserved_for: "Riservato",
    vip_section: "Livelli VIP",
    vip_enabled_lbl: "Abilita livelli VIP",
    vip_silver_threshold_lbl: "Soglia Argento (punti accumulati)",
    vip_gold_threshold_lbl: "Soglia Oro (punti accumulati)",
    vip_silver_bonus_lbl: "Bonus punti ticket Argento (%)",
    vip_gold_bonus_lbl: "Bonus punti ticket Oro (%)",
    vip_birthday_silver_lbl: "Punti compleanno Argento",
    vip_birthday_gold_lbl: "Punti compleanno Oro",
    vip_hint: "Il livello si calcola sui punti accumulati da sempre. Puoi comunque assegnarlo manualmente dalla scheda cliente.",
    min_tier_lbl: "Riservato al livello minimo",
    tier_all: "Tutti i clienti",
    vip_levels_dash: "Clienti per livello",
  },
  en: {
    tagline: "Loyalty program",
    login_title: "Operator Login",
    email: "Email", password: "Password", login: "SIGN IN", logout: "Logout",
    operator: "Operator",
    tap_card: "TAP THE CARD ON THE READER",
    reader_ready: "Reader ready", reader_off: "Reader not detected",
    search_customer: "SEARCH CUSTOMER", new_customer: "NEW CUSTOMER", catalog: "CATALOG",
    manual_uid: "Enter UID manually", scan_or_type: "Tap the card or type the UID",
    points: "STAR POINTS", card: "Card", customer_since: "Customer since", no_card: "No card",
    earn_points: "+ ADD POINTS", use_points: "USE POINTS",
    history: "HISTORY", edit: "EDIT", replace_card: "REPLACE CARD", back_home: "BACK TO HOME",
    back: "BACK", cancel: "CANCEL", confirm: "CONFIRM", save: "SAVE",
    valid_amount: "VALID AMOUNT", points_to_add: "POINTS TO CREDIT",
    current_balance: "Current balance", new_balance: "New balance",
    confirm_points: "CONFIRM", operation_done: "OPERATION COMPLETED",
    reward_delivered: "REWARD DELIVERED", remaining_balance: "Remaining balance",
    confirm_delivery: "CONFIRM DELIVERY", reward: "Reward", cost: "Cost",
    need_more: "NEED", select: "SELECT", available: "AVAILABLE", out_of_stock: "OUT OF STOCK",
    insufficient: "INSUFFICIENT POINTS",
    date_time: "Date/Time", operation: "Operation", amount: "Amount", balance: "Balance",
    search_placeholder: "Phone, first name, last name or card UID...",
    open_customer: "OPEN CUSTOMER", no_results: "No results", state: "Status",
    card_not_associated: "CARD NOT ASSOCIATED",
    assoc_new: "LINK TO NEW CUSTOMER", assoc_existing: "LINK TO EXISTING CUSTOMER",
    warning: "WARNING", duplicate_phone: "A customer with this phone already exists.",
    assoc_to_existing: "LINK THIS CARD TO THE EXISTING CUSTOMER", continue_anyway: "CONTINUE ANYWAY (ADMIN)",
    name: "First name", surname: "Last name", phone: "Mobile", birth_date: "Birth date",
    address: "Address", city: "City", province: "Province", zip: "ZIP",
    fiscal_code: "Fiscal code", notes: "Notes", gender: "Gender",
    privacy_consent: "Privacy consent", marketing_consent: "Marketing consent",
    required_fields: "First name, last name and mobile are required",
    customer_created: "Customer created", customer_updated: "Customer updated",
    card_associated: "Card linked", card_replaced: "Card replaced",
    new_card_uid: "New card UID",
    admin: "ADMIN", dashboard: "Dashboard", operators: "Operators", settings: "Settings",
    reports: "Reports", audit: "Audit Log", catalog_mgmt: "Catalog",
    today: "Today", yesterday: "Yesterday", last7: "Last 7 days", month: "Current month",
    prev_month: "Previous month", custom: "Custom",
    total_customers: "Total customers", new_today: "New today", new_month: "New this month",
    points_earned_period: "Points credited (period)", points_redeemed_period: "Points used (period)",
    points_circulating: "Points in circulation", rewards_delivered: "Rewards delivered",
    top_balance: "Top 10 by balance", top_earned: "Top 10 by earned points", top_rewards: "Top rewards",
    add_reward: "NEW REWARD", add_operator: "NEW OPERATOR", active: "Active", inactive: "Inactive",
    role: "Role", stock: "Stock", stock_tracking: "Track stock", category: "Category",
    points_required: "Points required", description: "Description", image: "Image",
    export_csv: "EXPORT CSV", reverse: "REVERSE", reason: "Reversal reason",
    program_rule: "Points rule", euro_per_step: "Euro per point (step)", points_per_step: "Points per step",
    session_timeout: "Customer session timeout (seconds)", program_name: "Program name",
    settings_saved: "Settings saved", error: "Operation failed",
    deactivate_customer: "Deactivate customer", activate_customer: "Reactivate customer",
    deactivate: "Deactivate", activate: "Activate",
    inactivity_warn: "Back to home due to inactivity",
    uid_label: "UID", loading: "Loading...",
    scan_ticket: "SCAN TICKET", keypad: "KEYPAD",
    drop_ticket: "Drop the ticket image here or tap to browse",
    analyzing: "AI ticket analysis in progress...",
    ticket_pending: "Tickets waiting from scanner", no_pending: "No pending tickets",
    auto_credit_lbl: "AUTO CREDIT", auto_credit_hint: "Reader tickets are credited automatically to the open customer",
    ticket_credited_title: "TICKET CREDITED", auto_tag: "AUTOMATIC",
    cancel_credit: "CANCEL CREDIT", credit_cancelled: "Credit cancelled",
    apply_ticket: "CREDIT", discard: "DISCARD",
    ticket_verify: "Verify ticket data", ticket_number_lbl: "Ticket number",
    puntato_lbl: "AMOUNT WAGERED (points base)", inserito_lbl: "Inserted", vincita_lbl: "Net win", pagabile_lbl: "Payable",
    tickets_nav: "VLT Tickets",
    happy_birthday: "HAPPY BIRTHDAY!", birthday_bonus_lbl: "Automatic birthday bonus",
    birthday_points_lbl: "Birthday bonus points",
    birthday_hint: "Credited automatically the first time the customer is identified on their birthday (once a year)",
    campaigns_nav: "Campaigns", add_campaign: "NEW CAMPAIGN", no_campaigns: "No campaigns yet. Create one to launch double points!",
    multiplier: "Multiplier", camp_from: "From", camp_to: "To",
    camp_days: "Days of the week", camp_days_hint: "No day selected = every day in the period",
    camp_all_days: "Every day", camp_scope: "Applies to",
    scope_ticket: "Scanned tickets only", scope_all: "All accruals",
    camp_running: "RUNNING", camp_scheduled: "SCHEDULED", camp_expired: "EXPIRED", camp_disabled: "DISABLED",
    camp_saved: "Campaign saved", camp_delete: "Delete campaign", camp_required: "Name and period required",
    bridge_nav: "Scanner", bridge_configured: "Bridge configured", bridge_not_configured: "Bridge not configured yet",
    bridge_setup_btn: "CONFIGURE AND DOWNLOAD PACKAGE (one time only)",
    bridge_download_btn: "DOWNLOAD PACKAGE", bridge_regen_btn: "REGENERATE TOKEN",
    bridge_regen_confirm: "Regenerate the token? The installed package will stop working and must be re-downloaded.",
    bridge_configured_toast: "Bridge configured, downloading...",
    bridge_steps_title: "Installation on the counter PC",
    bridge_step1: "Download the ZIP package and copy it to the PC connected to the fi-800R scanner",
    bridge_step2: "Extract the folder (Python required: python.org, check \"Add to PATH\")",
    bridge_step3: "Double-click AVVIA_BRIDGE.bat — no command line needed",
    bridge_step4: "Set the scanner to save JPGs into the \"scansioni\" folder (or edit \"folder\" in bridge_config.json)",
    vip_bronze: "Bronze", vip_silver: "Silver", vip_gold: "Gold",
    vip_level: "Level", vip_auto: "Automatic",
    vip_missing_points: "{n} ⭐ to reach {tier}",
    vip_total_earned: "Lifetime points earned",
    vip_bonus_tag: "VIP bonus",
    reserved_for: "Reserved",
    vip_section: "VIP levels",
    vip_enabled_lbl: "Enable VIP levels",
    vip_silver_threshold_lbl: "Silver threshold (lifetime points)",
    vip_gold_threshold_lbl: "Gold threshold (lifetime points)",
    vip_silver_bonus_lbl: "Silver ticket points bonus (%)",
    vip_gold_bonus_lbl: "Gold ticket points bonus (%)",
    vip_birthday_silver_lbl: "Silver birthday points",
    vip_birthday_gold_lbl: "Gold birthday points",
    vip_hint: "The level is based on lifetime earned points. You can still assign it manually from the customer page.",
    min_tier_lbl: "Reserved to minimum level",
    tier_all: "All customers",
    vip_levels_dash: "Customers by level",
  },
  zh: {
    tagline: "会员积分计划",
    login_title: "操作员登录",
    email: "邮箱", password: "密码", login: "登录", logout: "退出",
    operator: "操作员",
    tap_card: "请将会员卡放在读卡器上",
    reader_ready: "读卡器就绪", reader_off: "未检测到读卡器",
    search_customer: "查找客户", new_customer: "新客户", catalog: "礼品目录",
    manual_uid: "手动输入UID", scan_or_type: "刷卡或输入UID",
    points: "星星积分", card: "会员卡", customer_since: "注册日期", no_card: "无会员卡",
    earn_points: "+ 充值积分", use_points: "使用积分",
    history: "历史记录", edit: "编辑", replace_card: "更换会员卡", back_home: "返回首页",
    back: "返回", cancel: "取消", confirm: "确认", save: "保存",
    valid_amount: "有效金额", points_to_add: "待充值积分",
    current_balance: "当前余额", new_balance: "新余额",
    confirm_points: "确认", operation_done: "操作完成",
    reward_delivered: "礼品已发放", remaining_balance: "剩余积分",
    confirm_delivery: "确认发放", reward: "礼品", cost: "所需积分",
    need_more: "还需", select: "选择", available: "有货", out_of_stock: "缺货",
    insufficient: "积分不足",
    date_time: "日期/时间", operation: "操作", amount: "金额", balance: "余额",
    search_placeholder: "手机号、姓名或会员卡UID...",
    open_customer: "打开客户", no_results: "无结果", state: "状态",
    card_not_associated: "会员卡未绑定",
    assoc_new: "绑定到新客户", assoc_existing: "绑定到现有客户",
    warning: "注意", duplicate_phone: "该手机号已存在客户。",
    assoc_to_existing: "将此卡绑定到现有客户", continue_anyway: "仍然继续（管理员）",
    name: "名字", surname: "姓氏", phone: "手机号", birth_date: "出生日期",
    address: "地址", city: "城市", province: "省份", zip: "邮编",
    fiscal_code: "税号", notes: "备注", gender: "性别",
    privacy_consent: "隐私同意", marketing_consent: "营销同意",
    required_fields: "名字、姓氏和手机号为必填项",
    customer_created: "客户已创建", customer_updated: "客户已更新",
    card_associated: "会员卡已绑定", card_replaced: "会员卡已更换",
    new_card_uid: "新卡UID",
    admin: "管理", dashboard: "仪表盘", operators: "操作员", settings: "设置",
    reports: "报表", audit: "审计日志", catalog_mgmt: "礼品目录",
    today: "今天", yesterday: "昨天", last7: "最近7天", month: "本月",
    prev_month: "上月", custom: "自定义",
    total_customers: "客户总数", new_today: "今日新增", new_month: "本月新增",
    points_earned_period: "充值积分（期间）", points_redeemed_period: "使用积分（期间）",
    points_circulating: "流通积分", rewards_delivered: "已发放礼品",
    top_balance: "余额前10名", top_earned: "累计积分前10名", top_rewards: "热门礼品",
    add_reward: "新礼品", add_operator: "新操作员", active: "启用", inactive: "停用",
    role: "角色", stock: "库存", stock_tracking: "跟踪库存", category: "分类",
    points_required: "所需积分", description: "描述", image: "图片",
    export_csv: "导出CSV", reverse: "冲销", reason: "冲销原因",
    program_rule: "积分规则", euro_per_step: "每积分欧元（阈值）", points_per_step: "每档积分",
    session_timeout: "客户会话超时（秒）", program_name: "计划名称",
    settings_saved: "设置已保存", error: "操作失败",
    deactivate_customer: "停用客户", activate_customer: "重新启用客户",
    deactivate: "停用", activate: "启用",
    inactivity_warn: "因无操作返回首页",
    uid_label: "UID", loading: "加载中...",
    scan_ticket: "扫描彩票", keypad: "数字键盘",
    drop_ticket: "将彩票图片拖到此处或点击选择",
    analyzing: "AI正在分析彩票...",
    ticket_pending: "扫描仪待处理彩票", no_pending: "无待处理彩票",
    auto_credit_lbl: "自动充值", auto_credit_hint: "扫描仪的彩票会自动充值到当前打开的客户",
    ticket_credited_title: "彩票已充值", auto_tag: "自动",
    cancel_credit: "取消充值", credit_cancelled: "充值已取消",
    apply_ticket: "充值", discard: "丢弃",
    ticket_verify: "核对彩票数据", ticket_number_lbl: "彩票编号",
    puntato_lbl: "投注金额（积分基数）", inserito_lbl: "投入", vincita_lbl: "净赢", pagabile_lbl: "可兑付",
    tickets_nav: "VLT彩票",
    happy_birthday: "生日快乐！", birthday_bonus_lbl: "自动生日奖励",
    birthday_points_lbl: "生日奖励积分",
    birthday_hint: "客户生日当天首次识别时自动充值（每年一次）",
    campaigns_nav: "活动", add_campaign: "新活动", no_campaigns: "暂无活动。创建一个来开启双倍积分吧！",
    multiplier: "倍数", camp_from: "从", camp_to: "至",
    camp_days: "星期几", camp_days_hint: "未选择任何天 = 期间内每天",
    camp_all_days: "每天", camp_scope: "适用于",
    scope_ticket: "仅扫描的彩票", scope_all: "所有充值",
    camp_running: "进行中", camp_scheduled: "已排期", camp_expired: "已过期", camp_disabled: "已停用",
    camp_saved: "活动已保存", camp_delete: "删除活动", camp_required: "名称和期间为必填",
    bridge_nav: "扫描仪", bridge_configured: "桥接已配置", bridge_not_configured: "桥接尚未配置",
    bridge_setup_btn: "配置并下载安装包（仅一次）",
    bridge_download_btn: "下载安装包", bridge_regen_btn: "重新生成令牌",
    bridge_regen_confirm: "重新生成令牌？已安装的程序包将停止工作，需要重新下载。",
    bridge_configured_toast: "桥接已配置，正在下载...",
    bridge_steps_title: "在收银台电脑上安装",
    bridge_step1: "下载ZIP安装包并复制到连接fi-800R扫描仪的电脑上",
    bridge_step2: "解压文件夹（需要安装Python：python.org，勾选\"Add to PATH\"）",
    bridge_step3: "双击 AVVIA_BRIDGE.bat — 无需命令行",
    bridge_step4: "将扫描仪设置为把JPG保存到\"scansioni\"文件夹（或修改bridge_config.json中的\"folder\"）",
    vip_bronze: "铜牌", vip_silver: "银牌", vip_gold: "金牌",
    vip_level: "等级", vip_auto: "自动",
    vip_missing_points: "还差 {n} ⭐ 升级到{tier}",
    vip_total_earned: "累计获得积分",
    vip_bonus_tag: "VIP奖励",
    reserved_for: "专属",
    vip_section: "VIP等级",
    vip_enabled_lbl: "启用VIP等级",
    vip_silver_threshold_lbl: "银牌门槛（累计积分）",
    vip_gold_threshold_lbl: "金牌门槛（累计积分）",
    vip_silver_bonus_lbl: "银牌彩票积分奖励（%）",
    vip_gold_bonus_lbl: "金牌彩票积分奖励（%）",
    vip_birthday_silver_lbl: "银牌生日积分",
    vip_birthday_gold_lbl: "金牌生日积分",
    vip_hint: "等级根据累计获得的积分计算。也可以在客户页面手动指定。",
    min_tier_lbl: "最低等级专属",
    tier_all: "所有客户",
    vip_levels_dash: "按等级客户数",
  },
};

export const TIER_KEY = { BRONZO: "vip_bronze", ARGENTO: "vip_silver", ORO: "vip_gold" };
export const TIER_ICON = { BRONZO: "🥉", ARGENTO: "🥈", ORO: "🥇" };
export const TIER_RANK = { BRONZO: 0, ARGENTO: 1, ORO: 2 };

export const NEXT_LANG = { it: "en", en: "zh", zh: "it" };
export const LANG_LABEL = { it: "🇮🇹 IT", en: "🇬🇧 EN", zh: "🇨🇳 中文" };

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ps_lang") || "it");
  useEffect(() => localStorage.setItem("ps_lang", lang), [lang]);
  const t = useCallback((k) => dict[lang]?.[k] ?? dict.it[k] ?? k, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
